import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { compose } from '@xo-union/react-css-modules';
import Icon from '@xo-union/tk-component-icons';
import { DisplayElement } from '@xo-union/tk-ui-links';
import { Tooltip, TooltipContainer } from '@xo-union/tk-component-tooltips';
import GdsHouseholdModel from '~/glm/models/gds/gds-household-model';
import GdsGuestModel from '~/glm/models/gds/gds-guest-model';
import Collection from '~/glm/models/collection';
import { validMailingAddress } from '~/glm/utils/address-utils';
import styles from './contact-info-cell.scss';

const getIconColor = contactInfo => `${styles.contactIcon} ${contactInfo ? styles.blackIcon : styles.grayIcon}`;

const getLeaderName = guests => {
  const leader = guests.filter(g => g.isLeader)[0];
  return leader ? leader.firstName || leader.lastName : 'your guest';
};

const ContactInfoCellVariant = observer(({ household, guests, onContactClick, onCopyFormLinkClick }) => {
  const { getAddress, contactableByPhone, contactableByEmail } = household;
  const showCopyFormLink = !(validMailingAddress(getAddress) && contactableByPhone && contactableByEmail);

  const displayName = getLeaderName(guests);

  return (
    <div className={styles.contactInfoVariant}>
      <div className={styles.contactIcons} onClick={onContactClick}>
        <Icon
          data-testid="contact-icon-address"
          className={getIconColor(validMailingAddress(getAddress))}
          name="home"
          size="md"
        />
        <Icon data-testid="contact-icon-phone" className={getIconColor(contactableByPhone)} name="phone" size="md" />
        <Icon
          data-testid="contact-icon-email"
          className={getIconColor(contactableByEmail)}
          name="email_alternate"
          size="md"
        />
      </div>
      {showCopyFormLink ? (
        <TooltipContainer>
          <DisplayElement
            className={styles.copyFormLink}
            classes={compose({ 'tappable-area': styles.tappleArea })}
            as="button"
            size="md"
            onClick={() => onCopyFormLinkClick(displayName, household.id)}
          >
            Copy form link
          </DisplayElement>
          <Tooltip className={styles.tooltip}>
            <span>
              {`Send ${displayName} the link to their own unique address collection form so they can add or update their info.`}
            </span>
          </Tooltip>
        </TooltipContainer>
      ) : null}
    </div>
  );
});

ContactInfoCellVariant.propTypes = {
  household: PropTypes.instanceOf(GdsHouseholdModel).isRequired,
  guests: PropTypes.oneOfType([
    PropTypes.instanceOf(Collection),
    PropTypes.arrayOf(PropTypes.instanceOf(GdsGuestModel)),
  ]),
  onContactClick: PropTypes.func,
  onCopyFormLinkClick: PropTypes.func,
};

export default ContactInfoCellVariant;
